import React from 'react';
import { Outlet } from 'react-router';

import styled from 'styled-components';

import ErrorBoundary from 'components/error/ErrorBoundary';

import useScrollTop from 'hooks/common/useScrollTop';

import { QuickMenu } from '../../../common/QuickMenu';
import Header from '../../header/web/Header';

const CommonLayout = () => {
  useScrollTop(); // 페이지 이동 시 상단 이동

  return (
    <CommonPageStyled id="wrapper" className="trans-all-ease toggled">
      <Header />
      <Outlet />
      <QuickMenu />
    </CommonPageStyled>
  );
};

export default CommonLayout;

export const CommonPageStyled = styled.div`
  position: relative;
  display: block;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  min-width: 100vw;
`;
